<template>
  <div>
    <div v-if="isLogin">
      <InnerHeader />
    </div>
    <div v-else>
      <OuterHeader
        ref="OuterHeader"
        @showRegister="showRegister()"
        @closeRegister="closeRegister()" />
    </div>
  </div>
  <main role="main">
    <div id="main-wraper">
      <div class="page-wrapper" style="margin-top: 100px">
        <div class="container mt-md-5 mt-4">
          <div class="row justify-content-center">
            <div class="col-lg-12 justify-content-center">
              <div class="mb-3 text-center">
                <!-- <a
                  href="javascript:void(0)"
                  class="font-22 float-start text-dark"
                  @click="$router.go(-1)"
                  ><i class="bi bi-arrow-left"></i
                ></a> -->
                <h2 class="font-22 font-medium">{{ detail.title }}</h2>
              </div>
              <div class="row mb-4 px-md-0 px-2">
                <div v-html="detail.description"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SubFooter ref="SubFooter" @showRegister="showRegister()" />
      <MainFooter ref="MainFooter" @showRegister="showRegister()" />
      <SignUp ref="signupModal" />
    </div>
  </main>
</template>

<script>
import OuterHeader from "@/components/OuterHeader";
import MainFooter from "@/components/MainFooter";
import SignUp from "../../components/signup.vue";
import SubFooter from "@/components/SubFooter.vue";
import InnerHeader from "@/components/InnerHeader.vue";
export default {
  name: "TermsAndConditions",
  components: {
    OuterHeader,
    MainFooter,
    SignUp,
    SubFooter,
    InnerHeader,
  },
  data() {
    return {
      detail: {},
      mobile: this.$route.query.mobile,
      isLogin: localStorage.getItem("access_token") ?? null,
    };
  },
  mounted() {
    this.getDetail();
    window.scrollTo(-10000, -10000);
  },
  methods: {
    showRegister() {
      this.$refs.signupModal.showModal();
    },
    closeRegister() {
      this.$refs.signupModal.closeModal();
    },
    getDetail() {
      this.$api
        .getAPI({
          _action: "/cms/terms",
        })
        .then((res) => {
          this.detail = res;
        })
        .catch(() => {});
    },
  },
};
</script>
